import { makeStyles } from '@surveycake/rc';

export const useStyles = makeStyles([
  [
    'thirdPartyLogin',
    `
		display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 90%;
    max-width: 460px;
    height: 100vh;
    margin: 0 auto;
	`
  ],
  [
    'thirdParties',
    `
		width: 100%;
		margin-top: 30px;
	`
  ]
]);
